export default __webpack_public_path__ + "static/720-04d4c33edb67ef8b1be457c2411e8f21.jpg";